import type * as React from 'react';

import { Head } from '@xing-com/crate-career-hub-common';
import { LoggedOutFooter } from '@xing-com/crate-career-hub-logged-out-footer';
import { GridContainer, GridItem } from '@xing-com/grid';

import { MainPageContextWrapper } from './contexts/main-page-context-wrapper';
import { HeaderNavigation } from './header-navigation';
import { MainPageHeader } from './main-page-header';
import { TopicList } from './topic-list';

export const KarriereMainEntry: React.FC = () => (
  <>
    <Head />
    <MainPageContextWrapper>
      <GridContainer variant="FullSize">
        <GridItem span={12}>
          <HeaderNavigation />
          <MainPageHeader />
          <TopicList />
        </GridItem>
        <GridItem span={12}>
          <LoggedOutFooter />
        </GridItem>
      </GridContainer>
    </MainPageContextWrapper>
  </>
);
